import { CompanyMergeData, CompanyMergeSchema } from '../data/company.merge.data';
import { EmployeeMergeData, EmployeeMergeSchema } from '../data/employee.merge.data';
import { LeadAccountMergeData, LeadAccountMergeSchema } from '../data/lead.account.merge.data';
import { LeadContactMergeData, LeadContactMergeSchema } from '../data/lead.contact.merge.data';
import { LeadMergeData, LeadMergeSchema } from '../data/lead.merge.data';
import { BasicSiteMergeData, BasicSiteMergeSchema } from '../data/basic.site.merge.data';
import { ActivityEntityName } from '../../../../entities/shared/activity.entity.name';
import { MergeDataset } from '../../decorators/decorators/merge.dataset';
import { MergeSource } from '../../decorators/decorators/merge.source';

@MergeDataset({
    entity: ActivityEntityName.Lead
})
export class LeadMergeDataset {

    @MergeSource({
        schema: LeadMergeSchema
    })
    lead: LeadMergeData;

    @MergeSource({
        schema: LeadAccountMergeSchema
    })
    leadAccount: LeadAccountMergeData;

    @MergeSource({
        schema: LeadContactMergeSchema
    })
    leadContact: LeadContactMergeData;

    @MergeSource({
        schema: EmployeeMergeSchema
    })
    leadOwner: EmployeeMergeData;

    @MergeSource({
        schema: CompanyMergeSchema
    })
    leadCompany: CompanyMergeData;

    @MergeSource({
        schema: BasicSiteMergeSchema
    })
    leadSite: BasicSiteMergeData;

}